// vocabulary/literature.ts
import { VocabPair } from './types';

export const literature: VocabPair[] = [
  { word: "Metaphor", definition: "Comparison without using 'like' or 'as'" },
  { word: "Protagonist", definition: "Main character in a story" },
  { word: "Alliteration", definition: "Repetition of beginning consonant sounds" },
  { word: "Symbolism", definition: "Using objects to represent ideas" },
  { word: "Irony", definition: "Contrast between expectation and reality" },
  { word: "Foreshadowing", definition: "Hints about what will happen later" },
  { word: "Allegory", definition: "Story with hidden meaning" },
  { word: "Onomatopoeia", definition: "Words that imitate sounds" },
  { word: "Simile", definition: "Comparison using 'like' or 'as'" },
  { word: "Personification", definition: "Giving human qualities to non-human things" },
  { word: "Hyperbole", definition: "Deliberate exaggeration for effect" },
  { word: "Oxymoron", definition: "Combination of contradictory words" },
  { word: "Antagonist", definition: "Character who opposes the protagonist" },
  { word: "Setting", definition: "Time and place of a story" },
  { word: "Theme", definition: "Central message or meaning" },
  { word: "Climax", definition: "Turning point of a story" },
];